import readCookie from "@utils/read-cookie"
import appendUtmParams from "./appendUtmParams"
import * as Sentry from "@sentry/gatsby"
import { getSignupAppData, formatForMarketo } from "./signupAppRedirects"

export const submitMarketo = async (values, recaptcha, rejectOnError = true) => {
  const FASTLY_URL = process.env.FASTLY_URL || ""
  const res = await fetch(`${FASTLY_URL}/mform`, {
    headers: {
      "Content-Type": "application/json",
      "x-recaptcha-response": recaptcha,
    },
    method: "POST",
    body: values,
  })
  if (!res.ok) {
    // Note: These are likely 406s from Sig Sci
    const err = new Error(`Marketo network error: ${res.status}`, {
      cause: { code: "MarketoNetworkError", status: res.status },
    })
    if (rejectOnError) {
      return Promise.reject(err)
    }
    Sentry.captureException(err)
    return Promise.resolve(true)
  }
  const resJson = await res.json()

  // Note: Marketo edge service responds with an immediate 200, this probably doesn't happen
  if (!resJson.success) {
    const err = new Error("Marketo edge error", { cause: { code: "MarketoEdgeResponseError", status: res.status } })
    if (rejectOnError) {
      return Promise.reject(err)
    }
    Sentry.captureException(err)
    return Promise.resolve(true)
  }

  return resJson
}

export const formatMarketo = (values, geoIp) => {
  // Google Analytics IDs piped into marketo
  const gaIds = {
    ga: readCookie("_ga"),
    gid: readCookie("_gid"),
  }
  const utmParams = appendUtmParams()
  const formattedSignupAppData = formatForMarketo(getSignupAppData(values))

  const leadFormFieldEntries = Object.entries({
    ...gaIds,
    ...utmParams,
    firstName: values.FirstName,
    lastName: values.LastName,
    company: values.Company,
    email: values.Email,
    phone: values.Phone,
    address: values.Address,
    city: values.City,
    state: values.State,
    postalCode: values.PostalCode,
    country: values.Country,
    Opt_In_GDPR__c: values.Opt_In_GDPR__c,
    Eloqua_GeoIP__c: geoIp.country_code,
    GeoIP_Region__c: geoIp.region,
    productInterestDemoRequested: values.RequestDemo?.toString(),
    mostRecentProductInterestActivity: values.mostRecentProductInterestActivity,
    pricingFormDetails: values.pricingFormDetails ?? values.plans,
    pageLanguage: values.pageLanguage,
    mktoPersonNotes: values.Message,
    miscstringfield1: values.miscstringfield1,
    miscstringfield2: values.miscstringfield2,
    miscstringfield3: values.miscstringfield3,
    miscstringfield4: values.miscstringfield4,
    miscstringfield5: values.miscstringfield5,
    misctextareafield1: values.DetailsOfAttack,
    title: values.Title,
    comments: values.comments,
    website: values.Website,
    Job_Function__c: values.Role,
    Estimated_Monthly_BW_TB__c: values.Estimated_Monthly_BW_TB__c,
    Estimated_Monthly_Requests__c: values.Estimated_Monthly_Requests__c,
    How_did_you_hear_about_Fastly__c: values.How_did_you_hear_about_Fastly__c,
    mostRecentFormCompletedPageURL: formattedSignupAppData,
  }).filter(([, value]) => !!value)

  const leadFormFields = Object.fromEntries(leadFormFieldEntries)

  const data = {
    formId: values.formId,
    input: [
      {
        leadFormFields,
        cookie: readCookie("_mkto_trk"),
      },
    ],
  }
  return JSON.stringify(data)
}
